// Calendar module and connectors contracts.
import { z } from 'zod';

const Uuid = z.string().uuid();
const DateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data non valida');
const TimeOfDay = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Ora non valida');

export const CalendarQuery = z.object({
  from: DateOnly,
  to: DateOnly,
});

export const EventInput = z
  .object({
    title: z.string().trim().min(1, 'Scrivi un titolo').max(300),
    date: DateOnly,
    endDate: DateOnly.nullable().default(null),
    startTime: TimeOfDay.nullable().default(null),
    endTime: TimeOfDay.nullable().default(null),
    location: z.string().trim().max(300).nullable().default(null),
    description: z.string().max(5000).nullable().default(null),
    workspaceId: Uuid.nullable().default(null),
  })
  .refine((e) => !e.endTime || e.startTime, { message: 'Indica l’ora di inizio', path: ['startTime'] });
export type EventInput = z.input<typeof EventInput>;

export interface CalendarItem {
  id: string;
  kind: 'event' | 'task' | 'content';
  source: 'unitly' | 'google';
  title: string;
  startDate: string;
  startTime: string | null;
  endDate: string;
  endTime: string | null;
  allDay: boolean;
  color: string;
  workspaceId: string | null;
  workspaceName: string | null;
  refId: string;
  stateCategory: string | null;
  done: boolean;
  location: string | null;
  conferenceUrl: string | null;
  calendarName: string | null;
  canEdit: boolean;
}

// ------------------------------------------------------------------ connectors
export const AuthorizeInput = z
  .object({ scope: z.enum(['organization', 'user', 'workspace', 'workspace_user']), workspaceId: Uuid.nullable().default(null) })
  .refine((v) => (v.scope === 'workspace' || v.scope === 'workspace_user') === (v.workspaceId !== null), { message: 'Scegli uno spazio', path: ['workspaceId'] });
export const UpdateConnectionInput = z.object({ selectedCalendarIds: z.array(z.string().min(1).max(300)).max(50) });

export interface ConnectedCalendar {
  id: string;
  name: string;
  color: string | null;
  primary: boolean;
  selected: boolean;
}

export interface ConnectionInfo {
  id: string;
  scope: 'organization' | 'user' | 'workspace';
  /** Set when scope is 'workspace': which workspace's own calendar this is. */
  workspaceId: string | null;
  workspaceName: string | null;
  accountLabel: string | null;
  status: 'connected' | 'error' | 'expired' | 'disconnected';
  lastSyncAt: string | null;
  lastError: string | null;
  calendars: ConnectedCalendar[];
  mine: boolean;
  canManage: boolean;
}

export interface ConnectorInfo {
  key: 'google_calendar';
  name: string;
  description: string;
  /** Whether the server has OAuth client credentials. When false, nobody can connect yet. */
  configured: boolean;
  canConnectOrganization: boolean;
  connections: ConnectionInfo[];
}
